// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3slpO","title":"BackImages_title__3Rjwh","images":"BackImages_images__6KIcQ"};